import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-column" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-chevron-down text-xs ml-auto" }, null, -1)
const _hoisted_4 = { class: "flex flex-column gap-2" }
const _hoisted_5 = { class: "text-xl font-semibold" }
const _hoisted_6 = { class: "flex flex-column gap-2 mt-3" }
const _hoisted_7 = { class: "flex flex-column" }
const _hoisted_8 = { for: "now" }
const _hoisted_9 = { class: "text-sm text-gray-500" }
const _hoisted_10 = { class: "flex flex-column" }
const _hoisted_11 = { for: "departure" }
const _hoisted_12 = { class: "text-sm text-gray-500" }
const _hoisted_13 = { class: "flex flex-column" }
const _hoisted_14 = { for: "arrival" }
const _hoisted_15 = { class: "text-sm text-gray-500" }
const _hoisted_16 = { class: "flex justify-content-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Button = _resolveComponent("Button")!
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("button", {
      class: "plainButton flex gap-2 align-items-center flex-initial cursor-pointer w-full lg:w-fit",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`route_planner.time_select.${_ctx.eventType}`)), 1),
        (_ctx.eventType !== 'now')
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$moment(_ctx.eventAt).format("DD.MM.YYYY")) + " • " + _toDisplayString(_ctx.$moment(_ctx.eventAt).format("HH:mm")), 1))
          : _createCommentVNode("", true)
      ]),
      _hoisted_3
    ]),
    _createVNode(_component_OverlayPanel, {
      ref: "overlayPanel",
      class: "route-planner-panel",
      onHide: _ctx.saveSelection
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("route_planner.time_select.title")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", {
              class: _normalizeClass(["flex border-1 border-gray-300 border-round-2xl p-3 pb-2 gap-2 cursor-pointer", { 'border-primary-500': _ctx.eventType === 'now' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.eventType = 'now'))
            }, [
              _createVNode(_component_RadioButton, {
                "input-id": "now",
                modelValue: _ctx.eventType,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.eventType) = $event)),
                value: "now"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("route_planner.time_select.now")), 1),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("route_planner.time_select.now_description")), 1)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex border-1 border-gray-300 border-round-2xl p-3 pb-2 gap-2 cursor-pointer", { 'border-primary-500': _ctx.eventType === 'departure' }]),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.eventType = 'departure'))
            }, [
              _createVNode(_component_RadioButton, {
                "input-id": "departure",
                modelValue: _ctx.eventType,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.eventType) = $event)),
                value: "departure"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t("route_planner.time_select.departure")), 1),
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("route_planner.time_select.departure_description")), 1),
                (_ctx.eventType === 'departure')
                  ? (_openBlock(), _createBlock(_component_Calendar, {
                      key: 0,
                      class: "mt-2",
                      modelValue: _ctx.eventAt,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.eventAt) = $event)),
                      showTime: "",
                      panelClass: "addZindex"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex border-1 border-gray-300 border-round-2xl p-3 pb-2 gap-2 cursor-pointer", { 'border-primary-500': _ctx.eventType === 'arrival' }]),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.eventType = 'arrival'))
            }, [
              _createVNode(_component_RadioButton, {
                "input-id": "arrival",
                modelValue: _ctx.eventType,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.eventType) = $event)),
                value: "arrival"
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("route_planner.time_select.arrival")), 1),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("route_planner.time_select.arrival_description")), 1),
                (_ctx.eventType === 'arrival')
                  ? (_openBlock(), _createBlock(_component_Calendar, {
                      key: 0,
                      class: "mt-2",
                      modelValue: _ctx.eventAt,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.eventAt) = $event)),
                      showTime: "",
                      panelClass: "addZindex"
                    }, null, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ])
            ], 2)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(_component_Button, {
              class: "button primary w-full sm:w-fit",
              label: _ctx.$t('global.ok'),
              onClick: _ctx.toggle
            }, null, 8, ["label", "onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onHide"])
  ], 64))
}